import { createSelector } from 'reselect';

import { DirtyStates, ReduxState, UseFormData } from '../types';

const selectFormData = (state: ReduxState): UseFormData | undefined => state.form;
const selectDirtyStates = (
	state: ReduxState,
): { [key: string]: DirtyStates<string> | undefined } | undefined => selectFormData(state)?.dirtyStates;

export const selectDirtyState = (key: string): ((state: ReduxState) => DirtyStates<string>) =>
	createSelector(selectDirtyStates, dirtyStates => {
		const dirtyState = dirtyStates?.[key] ?? {};
		return dirtyState ? { ...dirtyState } : dirtyState;
	});
